import { Button, Text, Flex } from "@radix-ui/themes";

import { AlertDialog } from "@radix-ui/themes";

interface AssignmentConfirmDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  ordersWithAssignee: number;
  onConfirm: () => void;
}

const AssignmentConfirmDialog = ({
  isOpen,
  setIsOpen,
  ordersWithAssignee,
  onConfirm,
}: AssignmentConfirmDialogProps) => {
  return (
    <AlertDialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>Order assignment</AlertDialog.Title>
        <AlertDialog.Description size="2">
          <Text className="font-bold">
            {ordersWithAssignee} of the selected orders already have an
            assignee.
          </Text>
          <br />
          Would you like to overwrite them?
        </AlertDialog.Description>

        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray">
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button variant="solid" color="red" onClick={onConfirm}>
              Overwrite All
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};

export default AssignmentConfirmDialog;
